import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];
export const INTRO = 1.7;

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div" }) => {
  const M = motion[as];
  return (
    <M
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </M>
  );
};

export const Eyebrow = ({ children, light = false }) => (
  <p className={`flex items-center gap-3 font-mono text-xs uppercase tracking-[0.28em] ${light ? "text-copper-light" : "text-copper"}`}>
    <span className={`h-px w-8 ${light ? "bg-copper-light" : "bg-copper"}`} />
    {children}
  </p>
);
